/**
 * useDigestFanOut — D9 per-tenant fan-out for the Daily Status Digest
 * (Owner "All" mode). Mirrors useTenantAwareEntityList.ts's `useQueries` +
 * explicit `X-Tenant-Id` header override idiom — extracted as its own small
 * hook rather than force-fitting the digest into that hook's
 * pagination/EntityListResult-shaped contract, which the digest doesn't
 * match.
 */

import { useQueries, type UseQueryResult } from '@tanstack/react-query';
import { apiCall } from '@core/api/client';
import type { DailyStatusDigestData } from '@/api/dashboard';

export function useDigestFanOut(tenantIds: string[], date: string) {
  return useQueries({
    queries: tenantIds.map((tenantId) => ({
      queryKey: ['dashboard', 'daily-status', 'tenant', tenantId, date],
      queryFn: () =>
        apiCall<DailyStatusDigestData>('GET', '/v1/dashboard/daily-status', undefined, {
          query: { date },
          headers: { 'X-Tenant-Id': tenantId },
        }),
    })),
  }) as UseQueryResult<DailyStatusDigestData, Error>[];
}
